import { EnvironmentProviders, inject, makeEnvironmentProviders, provideAppInitializer } from '@angular/core';
import '@df/catalog-ui/recently-viewed/recently-viewed-engine';
import { RecentlyViewedService } from '@df/catalog-ui/recently-viewed/recently-viewed.service';

export function provideDfCatalogUiRecentlyViewed(): EnvironmentProviders {
    return makeEnvironmentProviders([
        provideAppInitializer(() => {
            inject(RecentlyViewedService).appInitialize();
        })
    ]);
}
